<main>
	<div class="hero is-fullheight-with-navbar is-dark">
		<div class="hero-body">
			<div class="container">
				<div class="columns has-text-centered is-centered">
					<div class="column is-9-tablet is-half-widescreen">
						<p class="big">
							404
						</p>
						<p class="is-size-5 mt-5">
							Nothing to see here, move along.
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</main>

<style>
    .big {
        font-size: 8em;
    }
</style>